import React, { useState } from 'react';
import { Button, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import Modal from '../shared/modal';
import { ModalBodyContainer, FieldTitles, FieldDescriptiveNote, ErrorMessage } from './css';
import { isValidEmail } from '../../utils/utils';
import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const ContractEmails = ({ open = false, setOpen, setData, error, signingAuthorityEmail }) => {
  const [email, setEmail] = useState(`${signingAuthorityEmail}`);
  const [emailError, setEmailError] = useState('');
  const [ccEmail, setCCEmail] = useState('');
  const [ccEmailError, setCCEmailError] = useState('');

  const locale = useLocaleContext();
  const {
    srtDashboardFM: {
      emailDetail: {
        header,
        contractAddress,
        contractAddressDetail,
        CCEmailAddress,
        CCEmailAddressDetail,
        confirm,
        emptyEmail,
        invalidEmail,
        CCEmailInvalid
      }
    }
  } = locale === 'en-US' ? EN : FR;

  const isValidated = () => {
    let check = true;
    if (email.length === 0) {
      setEmailError(emptyEmail);
      check = false;
    } else if (!isValidEmail(email)) {
      setEmailError(invalidEmail);
      check = false;
    }
    if (ccEmail.length > 0) {
      const ccEmails = ccEmail.replaceAll(' ', '').split(',');
      let totalCount = 0;
      ccEmails.forEach(emailAddress => {
        if (!isValidEmail(emailAddress)) {
          totalCount += 1;
        }
      });
      if (totalCount > 0) {
        setCCEmailError(`${totalCount} ${CCEmailInvalid}`);
        check = false;
      }
    }
    return check;
  };

  const onSubmit = () => {
    if (isValidated()) {
      setData({
        contractEmail: email,
        contractEmailCC: ccEmail
      });
    }
  };

  return (
    <Modal header={header} open={open} setOpen={setOpen}>
      <ModalBodyContainer>
        <FieldTitles>{contractAddress}</FieldTitles>
        <FieldDescriptiveNote>{contractAddressDetail}</FieldDescriptiveNote>
        <input
          className="frg-input-field color-light"
          value={email}
          onChange={e => {
            setEmailError('');
            setEmail(e.target.value);
          }}
        />
        <div style={{ color: 'red' }}><Typography block>{emailError}</Typography></div>
        <FieldTitles>{CCEmailAddress}</FieldTitles>
        <FieldDescriptiveNote>{CCEmailAddressDetail}</FieldDescriptiveNote>
        <input
          className="frg-input-field color-light"
          value={ccEmail}
          onChange={e => {
            setCCEmail(e.target.value);
          }}
        />
        <div style={{ color: 'red' }}><Typography block>{ccEmailError}</Typography></div>
        <Button variant={{ priority: 'high' }} type="button"
          
          onClick={() => {
            onSubmit();
          }}
        >
          {confirm}
        </Button>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </ModalBodyContainer>
    </Modal>
  );
};

ContractEmails.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setData: PropTypes.func.isRequired,
  signingAuthorityEmail: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired
};

export default ContractEmails;
